import { exitStageSearch } from './ExitStage'
import { CaseCard } from './CaseCard'
import { TreatmentCard } from './treatmentFixture'
import { useBandCards } from './useBandCards'
import { BoardSort, TREATMENT_PIPELINE_ID } from './useTreatmentBoard'

/**
 * The cases at one exit, drawn as the cases they are. `useBandCards` with the
 * membership search in place of a band's: the exits are what has left the
 * queue, and every card here still needs its procedures, plans and
 * appointments. Mounted only while the list is open, so nothing is fetched
 * for an exit nobody has opened.
 */
export function ExitCaseList({
  stage,
  sort,
  onOpen,
  search,
}: {
  stage: string
  sort: BoardSort
  onOpen: (card: TreatmentCard) => void
  /** Who is at the exit; the old pipeline's membership unless given. */
  search?: string
}) {
  const { cards, loading } = useBandCards({
    sort,
    searchOverride: search ?? exitStageSearch(TREATMENT_PIPELINE_ID, stage),
  })
  return (
    <>
      {loading && cards.length === 0 && <p className="px-1 py-2 text-body-sm text-subtle">Reading.</p>}
      {!loading && cards.length === 0 && <p className="px-1 py-2 text-body-sm text-subtle">Nobody yet.</p>}
      {cards.map((card) => (
        <CaseCard
          key={card.id}
          card={card}
          dragging={false}
          // Nothing to drag to in here.
          onDragStart={() => {}}
          onDragEnd={() => {}}
          onOpen={() => onOpen(card)}
        />
      ))}
    </>
  )
}
